export default __webpack_public_path__ + "static/media/2020_thumb.57708adb.jpg";